/*
 * @Author: your name
 * @Date: 2021-04-14 11:19:18
 * @LastEditTime: 2023-02-07 18:45:08
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Description: In User Settings Edi
 * @FilePath: \鲁南项目\src\modules\workshopEmergencyHandle\router.js
 */
const routes = [
  {
    path: '/workshop/emergency-handle', //修改
    name: 'workshopEH',
    component: () => import('@src/modules/workshopEmergencyHandle/view/emergencyHandle'),
    meta: {
      requireAuth: false,
      // module:"workshop"
      // routerAlive: true
    }
  },
  {
    path: '/workshop/emergency-handle-card', //修改
    name: 'workshopEHC',
    component: () => import('@src/modules/workshopEmergencyHandle/view/emergencyHandleCard'),
    meta: {
      requireAuth: false,
      routerAlive: true,
    }
  },
  {
    path: '/workshop/emergency-group',
    name: 'workshopGroup',
    component: () => import('@src/modules/workshopEmergencyHandle/view/emergencyGroup'),
    meta: {
      requireAuth: false,
      routerAlive: true
    }
  },
  {
    path: '/workshop/emergency-process-crud',
    name: 'process-crud',
    component: () => import('@src/modules/workshopEmergencyHandle/view/emergencyProcessCRUD'),
    meta: {
      requireAuth: false,
      // module:"workshop"
    }
  },
]

export default routes 